module.exports = __webpack_public_path__ + "img/dieindustrie_steiermark_logo.e69c93d8.png";